import { faExclamationTriangle, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import logoSanef from '../../images/logo.png';
import { SvgIcon } from '../utils/SvgIcon';
import { isMobileOnly, isTablet } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
  },
  paper: {
    width: '35vw',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: 0,
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
  },
}));

const LeftPanel = (props) => {
  const { statutWs, logout } = props;
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [subMenuIsOpen, setSubMenuIsOpen] = useState(false);
  const auth = useSelector(state => state["authentification"]);

  useEffect(() => {
    if (location && location.pathname.includes('/parametres')) {
      setSubMenuIsOpen(true);
    }
  }, [location]);

  const handleOnClose = () => {
    props.setOpen(false);
  };
  const openSubMenu = () => {
    setSubMenuIsOpen(!subMenuIsOpen);
  };

  return (
    <Modal className={classes.modal} open={props.open} onClose={handleOnClose}>
      <div className={classes.paper}>
        <div style={{ height: '75px' }}>
          <div id="bloc-logo-template" style={{ width: '10vw', marginLeft: '0' }}>
            <img src={logoSanef} alt="logo-sanef" style={{ width: '60px', display: 'flex', justifyContent: 'center' }} />
          </div>
        </div>
        <div style={{ paddingTop: isMobileOnly ? '0px' : isTablet ? '50px' : '75px'}}>
          <div className="menu-entry-left-panel" onClick={() => history.push('/equipements')}>
            {location && location.pathname.includes('/equipement') && <div className="menu-entry-left-panel-line" />}
            Équipements
          </div>
          {
            (auth.profil === 1 || auth.profil === 2) &&
            <>
              <div className="menu-entry-left-panel" onClick={() => history.push('/utilisateurs')}>
                {location && location.pathname.includes('/utilisateurs') && <div className="menu-entry-left-panel-line" />}
                Utilisateurs
              </div>
              <div className="menu-entry-left-panel" onClick={() => openSubMenu()}>
                {location && location.pathname.includes('/parametres') && <div className="menu-entry-left-panel-line" />}
                Paramétres
                <i className="fas fa-sort-down"
                  style={{ margin: subMenuIsOpen ? '-15px 0 0 20px' : '-5px 0 0 20px', transform: subMenuIsOpen ? 'none' : 'rotate(-90deg)' }} />
              </div>
              {
                subMenuIsOpen && <>
                  <div className="sub-menu-entry-left-panel" onClick={() => history.push('/parametres/gestion-indice-gravite')}>Gestion des indices de gravité</div>
                  <div className="sub-menu-entry-left-panel" onClick={() => history.push('/parametres/gestion-motif-acquittement')}>Gestion des motifs d'acquittement</div>
                  <div className="sub-menu-entry-left-panel" onClick={() => history.push('/parametres/gestion-commandes-references')}>Gestion des commandes</div>
                </>
              }
            </>
          }
        </div>
        <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {
            statutWs &&
            <div className="menu-entry-left-panel-btn" style={{ color: '#89A63A', backgroundColor: '#EDF4DA', cursor: 'default', fontSize: '3.5vw' }}>
              <SvgIcon color={'#89a63a'} name={'signal-stream'} size={'40px'} type="solid" />Connecté
            </div>
          }
          {
            !statutWs &&
            <div className="menu-entry-left-panel-btn" style={{ color: '#b18356', backgroundColor: '#f18d2d40', fontSize: '3.5vw' }}>
              <FontAwesomeIcon icon={faExclamationTriangle} style={{ marginRight: '10px' }} />Déconnecté
            </div>
          }
          <div className="menu-entry-left-panel-btn" style={{ color: '#ffffff', backgroundColor: '#0094ca', fontSize: '3.5vw' }} onClick={() => logout()}          >
            <FontAwesomeIcon icon={faSignOutAlt} style={{ margin: '0 10px' }} />Déconnexion
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LeftPanel;